export default {
  admin: {
    routesAllowed: ["*"],
  },
  machinesViewer: {
    routesAllowed: ["machines"],
  },
  productsViewer: {
    routesAllowed: ["product"],
  },
  meViewer: {
    routesAllowed: ["machines", "mappings"],
  },
  contentViewer: {
    routesAllowed: ["content"],
  },
  productsContentViewer: {
   routesAllowed: ["product", "content"],
 },
};

export const sectionsToRole = {
  ALL: "admin",
  ME: "meViewer",
  PRODUCT: "productsViewer",
  CONTENT: "contentViewer",
  PRODUCT_CONTENT: "productsContentViewer"
};
